import { useInstance } from 'intact-react';
import { eachChildren, findChildren, isComponentVNode } from '../utils';
import { isStringOrNumber } from 'intact-shared';
import { useState } from '../../hooks/useState';
import { Tag } from './';
import { Dropdown } from '../dropdown';
import { Tooltip } from '../tooltip';
export function useChildren() {
  var instance = useInstance();
  var children = useState([]);
  instance.watch('children', function (v) {
    var vNodes = [];
    eachChildren(v, function (vNode) {
      if (isTagOrContainsTag(vNode)) {
        vNodes.push(vNode);
      }
    });
    children.set(vNodes);
  });
  return children;
}
function isTagOrContainsTag(vNode) {
  if (isStringOrNumber(vNode)) return false;
  if (isComponentVNode(vNode, Tag)) {
    return true;
  }
  if (isComponentVNode(vNode, Dropdown) || isComponentVNode(vNode, Tooltip)) {
    var _vNode$props;
    return !!findChildren((_vNode$props = vNode.props) == null ? void 0 : _vNode$props.children, function (vNode) {
      return isTagOrContainsTag(vNode);
    });
  }
  return false;
}